import { render } from "./SetHoldBuyersModal.vue?vue&type=template&id=744e13f6&scoped=true&ts=true&lang=pug"
import script from "./SetHoldBuyersModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./SetHoldBuyersModal.vue?vue&type=script&lang=ts&setup=true"

import "./SetHoldBuyersModal.vue?vue&type=style&index=0&id=744e13f6&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744e13f6"]])

export default __exports__